<p-toolbar class="guide-toolbar">
  <div class="p-toolbar-group-start"></div>
  <div class="p-toolbar-group-center">
    <img class="logo" ngSrc="assets/victim/scamhelp-logo.svg" alt="logo" height="28" width="154" />
  </div>
  <div class="p-toolbar-group-end"></div>
</p-toolbar>
<div class="grid grid-cols-12 gap-4 mt-2 px-4 mx-auto">
  <div class="col-span-12 sm:col-span-12 md:col-span-12 lg:col-span-12">
    <router-outlet />
  </div>
</div>
